module.exports = kolibriGlobal.coreVue.components.UserTypeDisplay;